module.exports = __webpack_public_path__ + "img/blue_113.3393aa4b.png";